import * as React from 'react';
import { Breadcrumb } from '../Breadcrumb/breadcrumb';
import { NavGroups } from '../../enums/NavGroups';
import { Filter } from 'rcd-cpp-ui/ui/icon/Filter';
import './workspaceSetting.scss';
import { Data } from '../Icon/icon';
import { cn } from '../../utils';
import { DefaultData } from './DefaultData/defaultData';
import { DefaultFilters } from './DefaultFilters/defaultFilters';
import { Settings } from 'rcd-cpp-ui/ui/icon';
import { OtherSettings } from './OtherSettings/otherSettings';
import { useSelector } from '../../utils/useSelector';
import { BacktaggingSettings } from './BacktaggingSettings/backtaggingSettings';
import { NodeType } from '../../enums/NodeType';
import { PageName } from '../../enums/PageName';

enum Tab {
  DefaultData = 'Set Default Data',
  DefaultFilters = 'Set Default Filters',
  OtherSettings = 'Other Settings',
  BacktaggingSettings = 'Backtagging Settings'
}

const getIcon = (t: Tab) => {
  switch (t) {
    case Tab.DefaultData:
      return <Data />;
    case Tab.DefaultFilters:
      return <Filter />;
    case Tab.OtherSettings:
      return <Settings />;
    case Tab.BacktaggingSettings:
      return <Settings />;
  }
  return null;
};

export const WorkspaceSetting = () => {
  const selectedWorkspace = useSelector(s => s.planning?.selectedWorkspace);
  const [tab, setTab] = React.useState(Tab.DefaultData);
  if (!selectedWorkspace) return null;
  return (
    <div className="view">
      <div className="view-description">
        <Breadcrumb
          paths={[
            selectedWorkspace?.props?.name,
            NavGroups.Administration,
            PageName.WorkspaceSetting
          ]}
        />
      </div>
      <div className="workspace-setting">
        <nav>
          {[
            Tab.DefaultData,
            Tab.DefaultFilters,
            Tab.OtherSettings,
            selectedWorkspace?.labels?.includes(NodeType.AdminWorkspace)
              ? Tab.BacktaggingSettings
              : null
          ]
            .filter(t => t)
            .map(t => (
              <div
                className={cn({ active: tab == t })}
                onClick={() => setTab(t)}
              >
                {getIcon(t)}
                <span data-txt={t}>{t}</span>
              </div>
            ))}
        </nav>
        {tab == Tab.DefaultData && (
          <DefaultData setting={selectedWorkspace.setting} />
        )}
        {tab == Tab.DefaultFilters && <DefaultFilters />}
        {tab == Tab.OtherSettings && <OtherSettings />}
        {tab == Tab.BacktaggingSettings && <BacktaggingSettings />}
      </div>
    </div>
  );
};
